export default {
	setQuiz({ commit }, quiz) {
		commit('setQuiz', quiz);
	},
	chooseAnswer({ commit }, data){
		commit('chooseAnswer', data);
	},
	sendAnswer({commit}, data){
		commit('sendAnswer', data);
	},
	reQuiz({commit}){
		commit('reQuiz');
	}
};
